var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5352 52.2304H15V39.039C15 35.2961 18.0343 32.2618 21.7772 32.2618H44.2267M21.5352 52.2304V64.393M21.5352 52.2304H44.2267M79.2624 52.2304H85.5556V39.039C85.5556 35.2961 82.5213 32.2618 78.7783 32.2618H56.4499M79.2624 52.2304V64.393M79.2624 52.2304H56.4499M44.2267 32.2618V52.2304M44.2267 32.2618H50.3383M44.2267 52.2304H56.4499M56.4499 32.2618V52.2304M56.4499 32.2618H50.3383M50.3383 32.2618C49.1079 25.767 44.4687 12.7773 35.7552 12.7773C24.8633 12.7773 19.5383 32.2618 50.3383 32.2618ZM50.3383 32.2618C51.6292 25.767 56.7161 12.7773 66.7367 12.7773C79.2624 12.7773 75.0872 32.2618 50.3383 32.2618Z",
    stroke: "black",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3827_53031)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.3702,
    cy: 76.8204,
    rx: 29.8598,
    ry: 19.8204,
    transform: "rotate(15.4212 53.3702 76.8204)",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.384 82.408V85H40.104V84.04C40.104 83.432 40.192 82.856 40.368 82.312C40.56 81.752 40.76 81.288 40.968 80.92C41.176 80.552 41.52 80.144 42 79.696C42.48 79.232 42.848 78.904 43.104 78.712C43.36 78.504 43.808 78.168 44.448 77.704C45.104 77.24 45.52 76.944 45.696 76.816C46.704 76.08 47.432 75.432 47.88 74.872C48.328 74.312 48.552 73.64 48.552 72.856C48.552 72.072 48.312 71.448 47.832 70.984C47.352 70.504 46.688 70.264 45.84 70.264C44.96 70.264 44.232 70.528 43.656 71.056C43.08 71.568 42.784 72.272 42.768 73.168H40.104C40.104 71.552 40.648 70.232 41.736 69.208C42.84 68.184 44.216 67.672 45.864 67.672C47.384 67.672 48.656 68.12 49.68 69.016C50.704 69.912 51.216 71.168 51.216 72.784C51.216 74.064 50.92 75.144 50.328 76.024C49.752 76.888 48.792 77.8 47.448 78.76C47.24 78.92 46.856 79.192 46.296 79.576C45.736 79.96 45.32 80.256 45.048 80.464C44.792 80.672 44.512 80.96 44.208 81.328C43.904 81.68 43.696 82.04 43.584 82.408H51.384ZM62.3863 85L59.1463 80.944L55.9063 85H52.6903L57.4663 79.024L52.9543 73H56.0983L59.1223 77.032L62.1463 73H65.3143L60.8023 79.024L65.5783 85H62.3863Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3827_53031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    fill: "white",
    transform: "translate(23 51)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.66aac83533569951ef1e23fd12739fda.svg";
export { ForwardRef as ReactComponent };